export const ar = {
  appName: "Vira Studio",
  // nav
  navCreate: "إنشاء",
  navProfile: "الملف",
  navAccount: "الحساب",
  navLibrary: "المكتبة",
  navAdmin: "الإدارة",
  // auth
  login: "تسجيل الدخول",
  signup: "إنشاء حساب",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  displayName: "الاسم الظاهر",
  logout: "تسجيل الخروج",
  noAccount: "ليس لديك حساب؟",
  haveAccount: "لديك حساب بالفعل؟",
  forgotPassword: "هل نسيت كلمة المرور؟",
  resetPassword: "إعادة تعيين كلمة المرور",
  resetPasswordHint: "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
  sendResetLink: "إرسال رابط إعادة التعيين",
  resetEmailSent: "تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني.",
  backToLogin: "العودة لتسجيل الدخول",
  newPassword: "كلمة المرور الجديدة",
  updatePassword: "تحديث كلمة المرور",
  passwordUpdated: "تم تحديث كلمة المرور بنجاح.",
  // profile
  profileTitle: "الملف والهوية",
  entityContact: "الكيان والتواصل",
  clinicPhone: "رقم هاتف العيادة",
  clinicAddress: "عنوان العيادة",
  bio: "نبذة تعريفية",
  specialty: "التخصص",
  addSpecialty: "إضافة تخصص",
  scope: "نطاق الخبرة",
  services: "الخدمات والإجراءات",
  addTag: "إضافة",
  focusGeneral: "عام",
  focusSpecific: "التركيز على خدمات محددة",
  cohorts: "الجمهور المستهدف",
  addCohort: "إضافة شريحة",
  removeCohort: "حذف",
  ageFrom: "العمر من",
  ageTo: "إلى",
  gender: "النوع",
  male: "ذكر",
  female: "أنثى",
  both: "كلاهما",
  complaints: "الشكاوى والاهتمامات",
  archetypes: "النماذج الأصلية للعلامة",
  findArchetypes: "اكتشف نماذجك",
  branding: "العلامة التجارية",
  logo: "الشعار",
  uploadLogo: "رفع الشعار",
  generateLogo: "توليد شعار",
  saveLogo: "حفظ الشعار",
  removeLogo: "إزالة الشعار",
  logoArabic: "عربي",
  logoEnglish: "إنجليزي",
  referenceDesigns: "تصاميم مرجعية",
  doctorPhotos: "صور الطبيب",
  remove: "إزالة",
  // canvas assets
  canvasAssets: "أصول الكانفا",
  characterSheet: "ورقة الشخصية",
  characterSheetHint: "تُستخدم للحفاظ على ملامح وجه الطبيب في تصاميم الذكاء الاصطناعي.",
  generateCharacterSheet: "توليد ورقة الشخصية (٢)",
  canvasBackgrounds: "خلفيات الكانفا",
  uploadBackground: "رفع خلفية",
  generateBackground: "توليد خلفية (١)",
  backgroundPrompt: "وصف الخلفية (اختياري)",
  defaultBackground: "افتراضي",
  selectBackground: "اختر الخلفية",
  // delete guard
  deleteWarnTitle: "حمّل الصورة قبل الحذف",
  deleteWarnBody: "حمّل هذه الصورة قبل حذفها — لا يمكن استرجاعها.",
  downloadDelete: "تحميل وحذف",
  deleteAnyway: "حذف على أي حال",
  cancel: "إلغاء",
  // billing
  account: "الحساب",
  subscription: "الاشتراك",
  creditsRemaining: "الرصيد المتبقي",
  subscribe: "اشترك للبدء",
  planMonthly: "شهري",
  planQuarterly: "ربع سنوي",
  perMonth: "/ شهر",
  selectPlan: "اختر الباقة",
  instapayInstructions: "تعليمات الدفع عبر InstaPay",
  uploadProof: "رفع إثبات الدفع",
  proofUploaded: "تم رفع الإثبات — بانتظار التفعيل",
  // create
  createTitle: "إنشاء محتوى",
  topic: "الموضوع / عمّ تريد النشر",
  language: "اللغة",
  arabic: "العربية",
  english: "الإنجليزية",
  targetCohort: "الشريحة المستهدفة",
  allCohorts: "كل الشرائح",
  headline: "العنوان الرئيسي",
  addDoctorImage: "إضافة صورة الطبيب",
  addPhone: "إضافة رقم الهاتف",
  addLogo: "إضافة الشعار",
  generateCaption: "توليد النص",
  freeCanvas: "مجاني (Canvas)",
  aiDesign: "تصميم AI",
  credits2: "(٢ رصيد)",
  download: "تحميل",
  saveToLibrary: "حفظ في المكتبة",
  requestEdit: "طلب تعديل",
  retryFree: "إعادة المحاولة — مجاناً",
  subscribeToCreate: "اشترك للبدء في الإنشاء",
  // generic
  save: "حفظ",
  saving: "جارٍ الحفظ…",
  saved: "تم الحفظ",
  loading: "جارٍ التحميل…",
  generating: "جارٍ التوليد…",
  error: "حدث خطأ",
} as const;
